import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronDownCircleFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 30A14 14 0 1 0 2 16c0 10.4 9 14 14 14M9.3 13.3a1 1 0 0 1 1.4 0l5.3 5.3 5.3-5.3a1 1 0 0 1 1.4 0 1 1 0 0 1 0 1.4l-6 6a1 1 0 0 1-1.4 0l-6-6a1 1 0 0 1 0-1.4" /></svg>;
const ForwardRef = forwardRef(IconChevronDownCircleFilledSVG);
ForwardRef.displayName = "IconChevronDownCircleFilled";
export { ForwardRef as IconChevronDownCircleFilled };